export type FilterType = 'text' | 'select' | 'number' | 'date' | 'range' | 'multi-select' | 'dateRange' | 'autocomplete';

export interface FilterOption<T = unknown> {
  value: T;
  label: string;
}

export interface FilterConfig {
  id: string;
  label: string;
  type: FilterType;
  options?: FilterOption[];
  min?: number;
  max?: number;
  placeholder?: string;
}

export interface RangeValue {
  min: number | null;
  max: number | null;
}

export interface FilterChange {
  filterId: string;
  value: unknown;
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
